const { navigate } = require('gatsby');

const usingOpcoUrl = (path, shouldNavigate = false, navigateParams = {}) => {
  let newPath = path;
  switch (process.env.GATSBY_OPCO) {
    case 'PT':
      const shouldIncludeBusiness = newPath.includes('marketplace/') && !newPath.includes('business/marketplace');
      newPath = newPath.replace('product-list/', ''); // Removing product-list from product pages, product-list page still works
      newPath = newPath.replace('/nce-', '/'); // Removing nce from product urls
      newPath = newPath.replace('/basket', '/carrinho'); // Change basket to carrinho
      if (shouldIncludeBusiness) {
        newPath = newPath.replace('marketplace/', 'business/marketplace/');
      }
      break;
    default:
      break;
  }
  if (!shouldNavigate) {
    return newPath;
  }
  navigate(newPath, navigateParams);
};

module.exports = usingOpcoUrl;
